import { AutoIntegration } from '@givelify/api';
import { getAxiosClient } from '@givelify/utils';
import { ThunkAction } from 'redux-thunk';
import { makeApiRequest } from '../../api/utils/makeApiRequest';
import { AppActions, AppState } from '../index';
import { setIntegration } from './action';

export const getIntegration = (
    doneeId: number,
): ThunkAction<Promise<boolean>, AppState, undefined, AppActions> => {
    return async (dispatch) => {
        const httpRequest = getAxiosClient().get(
            `/donees/${doneeId}/integration/details`,
        );
        const response = await makeApiRequest<AutoIntegration>(httpRequest);

        dispatch(setIntegration(response.response ?? null));
        return true;
    };
};
